import React from 'react';
import { Menu, Badge } from 'antd';
import { Link } from 'react-router-dom';
import {
    MobileOutlined,
    BarChartOutlined,
    BarcodeOutlined,
    QuestionOutlined,
    DatabaseOutlined,
    DollarOutlined,
    MoneyCollectOutlined,
    OrderedListOutlined,
    HeartOutlined,
    UsergroupAddOutlined,
    PayCircleOutlined,
    UserOutlined
} from '@ant-design/icons';

// 图标映射表
const iconMap = {
    'mobile': MobileOutlined,
    'bar-chart': BarChartOutlined,
    'barcode': BarcodeOutlined,
    'question': QuestionOutlined,
    'database': DatabaseOutlined,
    'dollar': DollarOutlined,
    'money-collect': MoneyCollectOutlined,
    'ordered-list': OrderedListOutlined,
    'heart': HeartOutlined,
    'usergroup-add': UsergroupAddOutlined,
    'pay-circle': PayCircleOutlined,
    'user': UserOutlined
};

const renderIcon = (iconName) => {
    const IconComponent = iconMap[iconName];
    return IconComponent ? <IconComponent /> : null;
};

const renderMenuItem = item => ( // item.route 菜单单独跳转的路由
    <Menu.Item key={item.key}>
        
            <Link to={item.route || item.key}>   
                {item.icon && renderIcon(item.icon)}
                {
                    item.badgeCount ? 
                    (<Badge count={5} offset={[5, 0]} dot={true}>
                        <span className="nav-text">{item.title}</span>
                    </Badge>) : (
                        <span className="nav-text">{item.title}</span>
                    )
                }
            </Link>
    </Menu.Item>
);

const renderSubMenu = item => ( 
    <Menu.SubMenu
        key={item.key}
        title={
            <span>
                {item.icon && renderIcon(item.icon)}
                <span className="nav-text">{item.title}</span>
            </span>
        }
    >
        {item.subs.map(item => renderMenuItem(item))}
    </Menu.SubMenu>
);

export default ({ menus, ...props }) => (    
    <Menu {...props}>
        {menus && menus.map(item => 
            item.subs ? renderSubMenu(item) : renderMenuItem(item)
        )}
    </Menu>
);
